import { useEffect, useState } from 'react';
import { Col, Modal, Row, Tabs } from 'antd';
import { CustomButton, CustomTextArea, FormInput, FormSelect } from '../../../../../components';
import { InventoryViewAPI } from '../../../api/inventoryViewAPI';

interface IModal {
  setIsModalAddItem: (value: boolean) => void;
  isModalAddItem: boolean;
  formik?: any;
  onAddItem: (item: any) => void;
  selectedAssetId?: Asset | null;
}

export interface Asset {
  id: number;
  description: string;
  plate_code?: string;
  responsible?: string
  asset_group?: string;
  asset_class?: string;
  item?: { id: number; name: string };
  status?: { id: number; status: string };
  asset_class_id: number;
  vehicle?: {
    license_plate: string;
    engine_number: string;
    chassis_number: string;
    mechanical_inspection_date: string;
    soat_date: string;
    insurance_type: string;
    issue_date: string;
    doors: number;
    armor_level: number;
    fuel_type: string;
    observations: string;
  };
}
const ModalAddItemRolActivo = ({ setIsModalAddItem, isModalAddItem, formik, onAddItem, selectedAssetId }: IModal) => {
  const [assets, setAssets] = useState<Asset[]>([]);
  const [selectedAsset, setSelectedAsset] = useState<Asset | null>(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedToken = localStorage.getItem('auth');
        const parsedToken = storedToken ? JSON.parse(storedToken) : null;

        if (!parsedToken || !parsedToken.user) {
          console.error('No se encontró el usuario en el token.');
          return;
        }

        const data = await InventoryViewAPI.fetchParameters(
          ['assets_data'],
          { responsible_id: parsedToken.user.id }
        );

        if (data && Array.isArray(data.assets_data)) {
          setAssets(data.assets_data);

          if (selectedAssetId) {
            const preselectedAsset = data.assets_data.find((a: Asset) => a.id === selectedAssetId.id);
            if (preselectedAsset) {
              setSelectedAsset(preselectedAsset);
              formik.setValues({
                ...formik.values,
                itemable_id: preselectedAsset.id,
                plate_code: preselectedAsset.plate_code || '',
                responsible: preselectedAsset.responsible,
                asset_group: preselectedAsset.asset_group,
                asset_class: preselectedAsset.asset_class,
                item: preselectedAsset.item,
                status: preselectedAsset.status,
                vehicle: preselectedAsset.vehicle || null,
              });
            }
          }
        }
      } catch (error) {
        console.error('Error fetching assets:', error);
      }
    };
    fetchData();
  }, [selectedAssetId]);

  const handleAssetChange = (value: number) => {
    const asset = assets.find((a) => a.id === value);
    if (!asset) return;

    setSelectedAsset(asset);

    formik.setValues({
      ...formik.values,
      itemable_id: asset.id,
      plate_code: asset.plate_code || '',
      responsible: asset.responsible,
      asset_group: asset.asset_group,
      asset_class: asset.asset_class,
      item: asset.item,
      status: asset.status,
      vehicle: asset.vehicle || null,
    });
  };

  const handleConfirmAdd = () => {
    if (selectedAsset) {
      onAddItem(selectedAsset);
      setIsModalAddItem(false);
    }
  };

  return (
    <Modal
      width="95vw"
      title="Añadir activo"
      open={isModalAddItem}
      onCancel={() => setIsModalAddItem(false)}
      footer={[
        <CustomButton key="cancel" label="Cancelar" onClick={() => setIsModalAddItem(false)} buttonType="secondary" />,
        <CustomButton key="add" label="Añadir" onClick={handleConfirmAdd} />,
      ]}
    >
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Datos del activo" key="1">
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <FormSelect
                label="Activo"
                name="Activo"
                placeholder="Seleccione"
                value={selectedAssetId?.description}
                options={assets.map((x) => ({
                  name: x.description,
                  id: x.id.toString(),
                }))}
                onChange={(value) => {
                  formik.setFieldValue('itemable_id', value);
                  handleAssetChange(Number(value));
                }}
                disabled={!!selectedAssetId}
                onBlur={formik.handleBlur}
              />
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <FormInput label="Código/Placa" name="plate_code" value={selectedAssetId?.plate_code} disabled />
            </Col>
            <Col xs={24} sm={12}>
              <FormInput label="Clase de Activo" name="asset_class" value={selectedAssetId?.asset_class} disabled />
            </Col>
            <Col xs={24} sm={12}>
              <FormInput label="Grupo de Activos" name="asset_group" value={selectedAssetId?.asset_group} disabled />
            </Col>
            <Col xs={24} sm={12}>
              <FormInput label="Responsable" name="responsible" value={selectedAssetId?.responsible} disabled />
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <CustomTextArea label="Descripción" name="description" value={selectedAssetId?.description} disabled />
            </Col>
          </Row>
        </Tabs.TabPane>
        {selectedAsset?.vehicle && (
          <Tabs.TabPane tab="Vehículo" key="2">
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12}>
                <FormInput label="Placa" name="license_plate" value={selectedAsset.vehicle.license_plate} disabled />
              </Col>
              <Col xs={24} sm={12}>
                <FormInput label="Número de motor" name="engine_number" value={selectedAsset.vehicle.engine_number} disabled />
              </Col>
              <Col xs={24} sm={12}>
                <FormInput label="Número de chasis" name="chassis_number" value={selectedAsset.vehicle.chassis_number} disabled />
              </Col>
            </Row>
          </Tabs.TabPane>
        )}
      </Tabs>
    </Modal>
  );
};

export default ModalAddItemRolActivo;